import http from './http';
import { getApiRoute } from '../../config';
import store from '../store';
import { lowerFirst } from 'lodash';
const formatLastTickets = (ticketList) => {
  return ticketList.map((ticket) => {
    const id = ticket.codes.filter((code) => code.type === 'barcode')[0].id;
    const amount = ticket.totals.payment.total.value;
    const time = formatTime(ticket.createdAt);
    const productName = ticket.productName.toLowerCase();
    const status = ticket.status.toLowerCase();
    return {
      id,
      amount,
      time,
      status,
      productName,
      productTicket: ticket,
    };
  });
};
const formatTime = (time) => {
  const date = new Date(time);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');

  return `${hours}:${minutes} ${day}/${month}`;
};
const getdateTimeParams = () => {
  const now = new Date();
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const start = new Date(yesterday);
  start.setHours(0, 0, 0, 0);
  const end = new Date(yesterday);
  end.setHours(23, 59, 59, 999);
  return `&dateFrom=${start.toISOString()}&dateTo=${end.toISOString()}`;
};
const getParams = (size) => {
  const products = store.state.activeProducts.map((p) => p.productLabel).join(',');
  const { tenantId } = store.state;
  return `?size=${size}&page=1&tenants=${tenantId}&products=${products}`;
};
export default {
  async getLastTickets() {
    let numOfTickets = 0;
    let ticketsToDisplay = [];
    const numberOfTicketsToDisplay = 50;
    const { tenantId, token, currentActiveGame, thirdPartyInfo } = store.state;
    const { filterTicketListBy } = thirdPartyInfo || {};
    let size = numberOfTicketsToDisplay;
    let params = getParams(size);
    const mapFilters = {
      foreignWalletId: 'foreignWallets',
      foreignLocationId: 'foreignLocations',
    };
    const dateTimeParams = getdateTimeParams();
    if (filterTicketListBy && filterTicketListBy.length) {
      filterTicketListBy.forEach((filter) => {
        params += `&${mapFilters[lowerFirst(filter.name)]}=${filter.value}`;
      });
    }
    try {
      const ticketList = await http.get(
        `${getApiRoute('lastTicketsURL', { productName: currentActiveGame })}${getApiRoute('ticketHistory', { productName: currentActiveGame })}${params}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'X-Nsft-Games-Tenant-Id': tenantId,
          },
        },
      );
      ticketsToDisplay = [...ticketList.data.data];
      numOfTickets = ticketList.data.data.length;
      if (numOfTickets < numberOfTicketsToDisplay) {
        size = numberOfTicketsToDisplay - numOfTickets;
        params = getParams(size);
        if (filterTicketListBy && filterTicketListBy.length) {
          filterTicketListBy.forEach((filter) => {
            params += `&${mapFilters[lowerFirst(filter.name)]}=${filter.value}`;
          });
        }
        const ticketsFromDayBefore = await http.get(
          `${getApiRoute('lastTicketsURL', { productName: currentActiveGame })}${getApiRoute('ticketHistory', { productName: currentActiveGame })}${params}${dateTimeParams}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'X-Nsft-Games-Tenant-Id': tenantId,
            },
          },
        );
        ticketsToDisplay = [...ticketsToDisplay, ...ticketsFromDayBefore.data.data];
        ticketsToDisplay.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      }
      return formatLastTickets(ticketsToDisplay);
    } catch (error) {
      console.warn('Unable to get last tickets', error);
    }
  },
};
